import React from 'react';
import { isNewUI } from '../../utils/handleProgress';
import GenerateOtp from '../GenerateOtp/GenerateOtp';
import GenerateOtpOld from '../GenerateOtpOld/GenerateOtpOld';

const OtpPage =()=>{
    return isNewUI() ? <GenerateOtp /> :<GenerateOtpOld/>
}

export default OtpPage